import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { getFormValues, reduxForm } from 'redux-form'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Forms, Modals } from 'constants/index'
// components
import Header from 'components/UI/Modal/Header'
import { Button, BUTTON_LAYOUTS, Modal } from 'components/UI'
import { SwatchesColorPicker } from 'components/FormElements/ReduxForm'
// themes
import { Content, ActionsWrapper } from 'themes/views/modals'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'

const SetColorModal: React.FC<InjectedFormProps<any>> = ({ handleSubmit, change }) => {
  const {
    hideModal,
    modalData: { isOpen, width, onSubmit, initialColor }
  } = useModalData({ modalType: Modals.SET_COLOR_MODAL })

  const { formValues } = useSelector((state) => ({
    formValues: getFormValues(Forms.SET_COLOR_FORM)(state)
  }))

  const handleSubmitForm = () => {
    onSubmit(formValues)
    hideModal()
  }

  // reset on every open so a color picked for a previous target does not leak into this one
  React.useEffect(() => {
    if (isOpen) {
      change('color', initialColor || null)
    }
  }, [isOpen, initialColor])

  return (
    <Modal isOpen={isOpen} width={width} hideModal={hideModal}>
      <Header handleClearClick={hideModal}>Select a color</Header>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <Content>
          <SwatchesColorPicker name={'color'} initialColor={initialColor} />
        </Content>
        <ActionsWrapper>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE} onClick={handleSubmitForm} type={'button'}>
            Save
          </Button>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
            Cancel
          </Button>
        </ActionsWrapper>
      </form>
    </Modal>
  )
}

export default reduxForm<any>({ form: Forms.SET_COLOR_FORM })(SetColorModal)
